import type { Merger } from '#src/merge/mergers/merger.ts'

export const buildIncomingOverrideArrayMerger = (
  ...keys: string[]
): Merger => ({
  canMerge: ({ current, incoming, key }) =>
    keys.includes(key) && (Array.isArray(current) || Array.isArray(incoming)),
  merge: ({ incoming }) => incoming,
})

export const serviceRequestIncomingOverrideArrayMerger =
  buildIncomingOverrideArrayMerger('reasonCode', 'code', 'coding')

// A sig never changes after signing: a new sig is a new order. Edits happen
// only while the order is a draft, and the latest draft sig is the order.
// Earlier sigs are superseded, not alternate regimens, so incoming replaces
// the array rather than adding to it. Dosage items have no id/system/use to
// match on, so the element merger would append each new sig after the stale
// one and readers of [0] keep the old sig; prepending would still leave the
// stale sig in the array for readers that scan every entry.
// A missing or null incoming array still keeps the stored one.
export const medicationRequestDosageInstructionMerger: Merger = {
  canMerge: ({ incoming, key }) =>
    key === 'dosageInstruction' && Array.isArray(incoming),
  merge: ({ incoming }) => incoming,
}
